/**
 * Providers Helper Module
 * @module helpers/providers
 */

import { ASPEN_BASE_URL } from '@/utils'
import store from '@/store'

/**
 * Returns a logo URL for a given provider
 * @param  {Object} provider - a provider object
 * @param  {Object} options - size: small or large
 * @return {String} logo URL
 */
export const logoFor = (provider, options = {}) => {
  options = Object.assign({size: 'large'}, options)
  // Depending on the API, the logo can be in different properties
  let logo = provider[options.size + '_logo_url'] || (provider.logo_urls && provider.logo_urls[options.size])

  if (logo && !logo.match(/http/g)) {
    logo = ASPEN_BASE_URL + logo
  }
  return logo
}

/**
 * Returns folders that match a given provider
 * @param  {Object} provider - a provider object
 * @return {Array} matched folders
 */
export const foldersFor = (provider) => {
  // TODO (mikew): better way to access the store
  const folders = store.state.folders.folders
  if (folders && folders.length) {
    return folders.filter((folder) => {
      return folder.provider_id == provider.id
    })
  } else {
    return []
  }
}

/**
 * Returns the Business URL for a given provider
 * @param  {Object} provider - a provider object
 * @return {String} Business Url
 */
export const businessUrlFor = (provider) => {
  return `/business/provider/${provider.namespace}/`
}



// WEBPACK FOOTER //
// ./frontend/src/helpers/providers.js